import { formatPct } from "@/lib/api";

export function KpiCard({ label, value, sub, delta, testid, accent = "blue", info }) {
    const positive = delta != null && delta >= 0;
    const deltaColor =
        delta == null
            ? "text-[color:var(--bl-text-dim)]"
            : positive
              ? "text-[color:var(--bl-success)]"
              : "text-[color:var(--bl-danger)]";
    const accentColor =
        accent === "orange"
            ? "var(--bl-takealot-orange)"
            : accent === "green"
              ? "var(--bl-success)"
              : accent === "coffee"
                ? "var(--bl-accent-coffee)"
                : "var(--bl-takealot-blue)";
    return (
        <div
            data-testid={testid}
            className="border border-[color:var(--bl-border)] bg-[color:var(--bl-surface)] p-3 sm:p-4 rounded-sm relative overflow-hidden shadow-sm min-w-0"
        >
            <div
                className="absolute left-0 top-0 bottom-0 w-[3px]"
                style={{ backgroundColor: accentColor }}
            />
            <div className="text-[10px] uppercase tracking-[0.18em] text-[color:var(--bl-text-dim)] truncate flex items-center gap-1">
                <span className="truncate">{label}</span>
                {info}
            </div>
            <div
                className="mt-1.5 font-serif-display font-mono-num text-[color:var(--bl-text)] whitespace-nowrap truncate text-lg sm:text-xl 2xl:text-2xl"
                title={typeof value === "string" ? value : undefined}
            >
                {value}
            </div>
            <div className="mt-1 flex items-center gap-2 text-xs flex-wrap">
                {delta != null && (
                    <span className={`font-mono-num ${deltaColor}`}>
                        {formatPct(delta)}
                    </span>
                )}
                {sub && (
                    <span className="text-[color:var(--bl-text-dim)] truncate">
                        {sub}
                    </span>
                )}
            </div>
        </div>
    );
}

export function PageHeader({ title, subtitle, children }) {
    return (
        <div className="flex items-end justify-between flex-wrap gap-3 mb-5 sm:mb-6">
            <div className="min-w-0">
                <h1 className="font-serif-display text-3xl sm:text-4xl text-[color:var(--bl-text)] tracking-tight break-words">
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-1 text-xs sm:text-sm text-[color:var(--bl-text-dim)] break-words">
                        {subtitle}
                    </p>
                )}
            </div>
            <div className="flex items-center gap-2 flex-wrap">{children}</div>
        </div>
    );
}
